/**
 * Paleta de marca OLDELVAL GO — fuente única de verdad.
 *
 * Escala azul oficial del sistema (reemplazó a la paleta corporativa
 * anterior tras la validación con cliente). Define la escala junto con
 * el builder que arma el bloque `primitive` + `semantic` que consume
 * PrimeNG en el arranque (app.config.ts).
 */

export type BrandScale = {
    50: string;
    100: string;
    200: string;
    300: string;
    400: string;
    500: string;
    600: string;
    700: string;
    800: string;
    900: string;
    950: string;
};

/**
 * Escala azul oficial "Oldelval GO" — base #1a4fbe, recalibrada junto al
 * cliente a partir de los colores del logo (hue ~220°, saturación
 * moderada en toda la escala para que rellenos grandes como el sidebar
 * no resulten "cargados" a la vista).
 */
export const OLDELVAL_BRAND_BLUE: BrandScale = {
    50:  '#eff3fa',
    100: '#d7e0f4',
    200: '#a8beeb',
    300: '#6990e2',
    400: '#3068df',
    500: '#1a4fbe',
    600: '#174097',
    700: '#133376',
    800: '#102759',
    900: '#0d1c3d',
    950: '#091225',
};

/** Tono usado para el sidebar (superficie de marca a gran escala). */
export const OLDELVAL_SURFACE_BRAND = OLDELVAL_BRAND_BLUE[700];

/** Cian del wordmark "GO" del logo — acento puntual. */
export const OLDELVAL_ACCENT = '#00bfff';

/**
 * Construye el delta `primitive`/`semantic` de PrimeNG (Aura) para la
 * escala de marca. Usado por `app.config.ts` para el preset inicial.
 */
export function buildBrandPresetExtension(scale: BrandScale) {
    return {
        primitive: {
            blue: { ...scale },
        },
        semantic: {
            primary: {
                50: scale[50],
                100: scale[100],
                200: scale[200],
                300: scale[300],
                400: scale[400],
                500: scale[500],
                600: scale[600],
                700: scale[700],
                800: scale[800],
                900: scale[900],
                950: scale[950],
            },
            colorScheme: {
                light: {
                    primary: {
                        color: scale[500],
                        contrastColor: '#ffffff',
                        hoverColor: scale[600],
                        activeColor: scale[700],
                    },
                    highlight: {
                        background: scale[50],
                        focusBackground: scale[100],
                        color: scale[700],
                        focusColor: scale[800],
                    },
                },
                dark: {
                    primary: {
                        color: scale[400],
                        contrastColor: scale[950],
                        hoverColor: scale[300],
                        activeColor: scale[200],
                    },
                    highlight: {
                        background: `color-mix(in srgb, ${scale[400]}, transparent 84%)`,
                        focusBackground: `color-mix(in srgb, ${scale[400]}, transparent 76%)`,
                        color: 'rgba(255,255,255,.87)',
                        focusColor: 'rgba(255,255,255,.87)',
                    },
                },
            },
        },
    };
}
